document.addEventListener('click',function(event){
  var button=event.target.closest('[data-quantity-minus],[data-quantity-plus]');
  if(!button)return;
  var selector=button.closest('[data-quantity-selector]');
  var input=selector&&selector.querySelector('input[name="quantity"]');
  if(!input)return;
  var minimum=Number(input.min||1);
  var maximum=input.max?Number(input.max):Infinity;
  var step=Number(input.step||1);
  var current=Number(input.value)||minimum;
  var direction=button.hasAttribute('data-quantity-plus')?1:-1;
  input.value=String(Math.min(maximum,Math.max(minimum,current+(direction*step))));
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
